import { LifeStage } from '../types/game';

export const lifeStages: LifeStage[] = [
  {
    id: 'childhood',
    name: 'Childhood',
    ageRange: '0-17',
    description: 'Foundation years - education, family, and early development',
    color: '#fbbf24',
    icon: '🎈',
  },
  {
    id: 'early-adulthood',
    name: 'Early Adulthood',
    ageRange: '18-24',
    description: 'Transition to independence - education, career choices, and relationships',
    color: '#3b82f6',
    icon: '🎓',
  },
  {
    id: 'young-adult',
    name: 'Young Adult',
    ageRange: '25-34',
    description: 'Building career, relationships, and financial stability',
    color: '#8b5cf6',
    icon: '💼',
  },
  {
    id: 'middle-age',
    name: 'Middle Age',
    ageRange: '35-49',
    description: 'Peak career years - family, investments, and long-term planning',
    color: '#10b981',
    icon: '🏠',
  },
  {
    id: 'mature-adult',
    name: 'Mature Adult',
    ageRange: '50-64',
    description: 'Pre-retirement planning and life balance optimization',
    color: '#f59e0b',
    icon: '⚖️',
  },
  {
    id: 'senior',
    name: 'Senior Years',
    ageRange: '65+',
    description: 'Retirement, legacy, and enjoying the fruits of life decisions',
    color: '#ef4444',
    icon: '🌅',
  },
];
